/** @format */

import {Box, styled, Typography} from '@mui/material';

import SecondaryMediumButton from 'components/buttons/SecondaryMediumButton';

export const Wrapper = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  overflow: 'hidden',
  borderRadius: '8px',
  marginTop: theme.spacing(6),
}));

export const TitleBox = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginTop: theme.spacing(6),
}));

export const TitleActions = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
}));

export const ReportButton = styled(SecondaryMediumButton)(({theme}) => ({
  padding: theme.spacing(4, 8),
  borderRadius: '8px',
  background: '#202020',
  boxShadow: '1px 1px 5px 0px rgba(0, 0, 0, 0.05)',
  color: '#F1F1F1',
  fontSize: '14px',
  fontWeight: 400,
  '&:hover': {
    background: '#202020',
  },
}));

export const Title = styled(Typography)(() => ({
  fontStyle: 'normal',
  fontWeight: 700,
  fontSize: '24px',
  lineHeight: '30px',
  color: '#F1F1F1',
}));
